<template>
    <DForm @submit.prevent="">
        <DCard
            :title="__('orders.customer_data.customer_information')"
            padding
            class="mb-3"
        >
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                >
                    {{ __('orders.show.' + orderData.customer.customer_type) }}
                </DCol>
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.customers.customer_type')"
                    >
                        <span class="fw-bold">{{ __('orders.show.' + orderData.customer.customer_type) }}</span>
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow v-if="form.customer_type === 'geschäftlich'">
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                >
                    {{ orderData.customer.company }}
                </DCol>
                <DCol
                    col="1"
                    class="m-auto"
                >
                    <a
                        v-if="isNorwayCustomer"
                        id="check-company"
                        class="check"
                        :href="checkLink(form.company)"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Check</a>
                </DCol>
                <DCol>
                    <DFormRow
                        :label="__('customers.common.company')"
                        :is-required="true"
                        :error="errors.company"
                    >
                        <DInput
                            id="orders_company"
                            v-model="form.company"
                            :placeholder="__('customers.common.company')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow v-if="form.customer_type === 'geschäftlich'">
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                />
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.common.company2')"
                        :hint="__('customers.common.company2_hint')"
                        :error="errors.company2"
                    >
                        <DInput
                            id="orders_company2"
                            v-model="form.company2"
                            :placeholder="__('customers.common.company2')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow v-if="form.customer_type === 'geschäftlich'">
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                />
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.common.legal_form')"
                        :error="errors.legal_form"
                    >
                        <DSelect
                            id="legal_form"
                            v-model="form.legal_form"
                            :options="legalForms"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                >
                    {{ orderData.customer.firstname }}
                </DCol>
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.common.firstname')"
                        :is-required="true"
                        :error="errors.firstname"
                    >
                        <DInput
                            id="orders_firstname"
                            v-model="form.firstname"
                            :placeholder="__('customers.common.firstname')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                >
                    {{ orderData.customer.lastname }}
                </DCol>
                <DCol
                    col="1"
                    class="m-auto"
                >
                    <a
                        v-if="isNorwayCustomer"
                        id="check-full-name"
                        class="check"
                        :href="checkLink(fullName)"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Check</a>
                </DCol>
                <DCol>
                    <DFormRow
                        :label="__('customers.common.lastname')"
                        :is-required="true"
                        :error="errors.lastname"
                    >
                        <DInput
                            id="orders_lastname"
                            v-model="form.lastname"
                            :placeholder="__('customers.common.lastname')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow v-if="form.customer_type === 'geschäftlich'">
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                />
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.customers.vat_number')"
                        :error="errors.vat_number"
                    >
                        <DInput
                            id="orders_vat_number"
                            v-model="form.vat_number"
                            :placeholder="__('customers.customers.vat_number')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow v-if="form.customer_type === 'geschäftlich'">
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                />
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.customers.business_id')"
                        :is-required="form.country_code === 'FI'"
                        :error="errors.business_id"
                    >
                        <DInput
                            id="orders_business_id"
                            v-model="form.business_id"
                            :placeholder="__('customers.customers.business_id')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow v-if="form.customer_type === 'geschäftlich'">
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                />
                <DCol
                    col="1"
                    class="m-auto"
                >
                    <a
                        v-if="isNorwayCustomer"
                        id="check-business-id-norway"
                        class="check"
                        :href="checkLink(form.business_id_norway, true)"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Check</a>
                </DCol>
                <DCol>
                    <DFormRow
                        :label="__('customers.customers.business_id_norway')"
                        :is-required="isNorwayBusinessIdEnabled && isNorwayCustomer"
                        :error="errors.business_id_norway"
                    >
                        <DInput
                            id="orders_business_id_norway"
                            v-model="form.business_id_norway"
                            :placeholder="__('customers.customers.business_id_norway')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
        </DCard>
        <DCard
            :title="__('orders.customer_data.address')"
            padding
            class="mb-3"
        >
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                >
                    {{ orderData.customer.address1 }}
                </DCol>
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.common.address1')"
                        :is-required="isNorwayCustomer === false"
                        :error="errors.address1"
                    >
                        <DInput
                            id="orders_address1"
                            v-model="form.address1"
                            :placeholder="__('customers.common.address1')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                />
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.common.address2')"
                        :error="errors.address2"
                    >
                        <DInput
                            id="orders_address2"
                            v-model="form.address2"
                            :placeholder="__('customers.common.address2')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                >
                    {{ orderData.customer.postal_code }}
                </DCol>
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.common.postal_code')"
                        :is-required="true"
                        :error="errors.postal_code"
                    >
                        <DInput
                            id="orders_postal_code"
                            v-model="form.postal_code"
                            :placeholder="__('customers.common.postal_code')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                >
                    {{ orderData.customer.city }}
                </DCol>
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.common.city')"
                        :is-required="true"
                        :error="errors.city"
                    >
                        <DInput
                            id="orders_city"
                            v-model="form.city"
                            :placeholder="__('customers.common.city')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                >
                    {{ countryName }}
                </DCol>
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.common.country')"
                        :is-required="true"
                        :error="errors.country_code"
                    >
                        <DSelect
                            id="orders_country_code"
                            v-model="form.country_code"
                            :options="countries"
                            :placeholder="__('customers.common.select_country')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
        </DCard>
        <DCard
            :title="__('orders.customer_data.communication')"
            padding
            class="mb-3"
        >
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                >
                    {{ orderData.customer.email }}
                </DCol>
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.common.email')"
                        :is-required="true"
                        :error="errors.email"
                    >
                        <DInput
                            id="orders_email"
                            v-model="form.email"
                            :placeholder="__('customers.common.email')"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                >
                    {{ orderData.customer.phone }}
                </DCol>
                <DCol
                    col="1"
                    class="m-auto"
                >
                    <a
                        v-if="isNorwayCustomer"
                        id="check-phone"
                        class="check"
                        :href="checkLink(form.phone)"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Check</a>
                </DCol>
                <DCol>
                    <DFormRow
                        :label="__('customers.common.phone')"
                        :error="errors.phone"
                    >
                        <DPhoneInput
                            id="orders_phone"
                            v-model="form.phone"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                />
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.common.mobilenumber')"
                        :error="errors.mobilenumber"
                    >
                        <DPhoneInput
                            id="orders_mobilenumber"
                            v-model="form.mobilenumber"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
            <DRow>
                <DCol
                    col="2"
                    class="m-auto fw-bold"
                />
                <DCol
                    col="1"
                    class="m-auto"
                />
                <DCol>
                    <DFormRow
                        :label="__('customers.customers.fax')"
                        :error="errors.fax"
                    >
                        <DPhoneInput
                            id="orders_fax"
                            v-model="form.fax"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
        </DCard>
        <DFormControls
            :cancel-route="cancelRoute"
            :submit-message="__('orders.customer_data.create_customer_and_accept_order')"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm, usePage } from '@inertiajs/vue3'
import { computed, ref } from 'vue'
import { route } from '~@/Composables/route'

const props = defineProps({
    orderData: {
        type: Object,
        default: () => { return {} }
    },
    countries: {
        type: Object,
        default: () => { return {} }
    },
    legalForms: {
        type: Object,
        default: () => { return {} }
    }
})

const form = useForm({
    customer_type: props.orderData.customer.customer_type ?? null,
    firstname: props.orderData.customer.firstname ?? null,
    lastname: props.orderData.customer.lastname ?? null,
    address1: props.orderData.customer.address1 ?? null,
    address2: props.orderData.customer.address2 ?? null,
    city: props.orderData.customer.city ?? null,
    country_code: props.orderData.customer.country_code ?? null,
    postal_code: props.orderData.customer.postal_code ?? null,
    email: props.orderData.customer.email ?? null,
    phone: props.orderData.customer.phone ?? null,
    mobilenumber: props.orderData.customer.mobilenumber ?? null,
    fax: props.orderData.customer.fax ?? null,
    company: props.orderData.customer.company ?? null,
    company2: props.orderData.customer.company2 ?? null,
    legal_form: props.orderData.customer.legal_form ?? null,
    vat_number: props.orderData.customer.vat_number ?? null,
    business_id_norway: props.orderData.customer.business_id_norway ?? null,
    personal_id_norway: props.orderData.customer.personal_id_norway ?? null,
    business_id: props.orderData.customer.business_id ?? null,
    ssn: props.orderData.customer.ssn ?? null,
    brand_id: props.orderData.customer?.brand?.id ?? null
})

const errors = ref({})

const countryName = computed(() => {
    return props.countries.filter(item => item.value === form.country_code)[0]?.label ?? ''
})

const isNorwayCustomer = computed(() => {
    return form.country_code === 'NW' || form.country_code === 'NO'
})

const fullName = computed(() => {
    return `${form.firstname ?? ''}+${form.lastname}`
})

const isNorwayBusinessIdEnabled = computed(() => usePage().props.tenantSettings?.norway_id)

function checkLink (value = null, businessIdNorway = false) {
    if (businessIdNorway === true) {
        return `https://w2.brreg.no/enhet/sok/detalj.jsp?orgnr=${value}`
    }
    return `https://www.1881.no/?query=${value}`
}

const cancelRoute = computed(() => {
    return route('orders.details', { order: props.orderData.orderNumber, client: props.orderData.client })
})

function submitForm () {
    form.post(route('orders.one_webshop.create-customer-and-accept', { orderUuid: props.orderData.orderNumber }), {
        onError: (error) => {
            errors.value = error
        }
    })
}
</script>

<style scoped>
    .row {
        margin-bottom: 25px;
    }
    a.check {
        color: rgba(0, 0, 0, 0.6)!important;
        text-decoration: underline;
    }
</style>
